var account = "Account";
var accountSettings = "Account Settings";
var charging = "Charging";
var contactInfo = "Contact Info";
var dashboard = "Dashboard";
var home = "Home";
var myProducts = "My Products";
var orderHistory = "Order History";
var paymentMethod = "Payment Method";
var profileSettings = "Profile Settings";
var referAndEarn = "Refer and Earn";
var signOut = "Sign Out";
var en_US = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, en_US as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
